export default (params) => ({
  trigger: {
    name: 'web.screen',
    params: params,
  },
  config: {
    schema: {
      width: {
        type: 'number',
      },
      height: {
        type: 'number',
      },
      viewport_width: {
        type: 'number',
      },
      viewport_height: {
        type: 'number',
      },
      color_depth: {
        type: 'number',
      },
    },
    event: {
      name: 'screen',
      params: {
        sub_feature: null,
      },
    },
  },
});
